module.exports = __webpack_public_path__ + "img/card-trans.a5aef2cb.png";